export interface ILocation {
  id?: string;
  name: string;
  date: string;
  coord_lat: number;
  coord_long: number;
  habitatage?: HabitatAge;
  habitatage_comment?: string;
  acoustic?: boolean;
  cmr?: boolean;
  edna?: boolean;
  comments?: string;
  createdby?: string;
  groupid?: string;
  groupname?: string;
  userlogin?: string;
  photoCount?: number;
}

export interface ILocationPhoto {
  id?: string;
  photo_filename?: string;
  locationname: string;
  photoid: string;
  trapname?: string;
}

export enum WEATHER_ENUM {
  RAINY = 'Rainy',
  CLOUDY = 'Cloudy',
  SUNNY = 'Sunny',
}

export enum LAYOUT_TYPE_ENUM {
  Grid = 'Grid',
  Transect = 'Transect',
  SinglePoint = 'Single Point',
}

export enum HABITATAGES {
  "0-5" = "0-5",
  "5-20" = "5-20",
  "20-40" = "20-40",
  "40-60" = "40-60",
  "60-80" = "60-80",
  "80-100" = "80-100",
  "100-120" = "100-120",
  "120-140" = "120-140",
  "140-160" = "140-160",
  "160-180" = "160-180",
  "180-200" = "180-200",
  "200+" = "200+"
}
export type HabitatAge = keyof typeof HABITATAGES;

export enum SURVEY_TYPE_ENUM {
  cmr = 'CMR',
  acoustic = 'Acoustic',
  edna = 'eDNA',
}
